import React, { useEffect, useState } from 'react'
import TransLoco from 'shared/components/trans-loco'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { Hint } from '@systemeio/ui'
import { useCalendars } from 'modules/profile/integrations/google/hooks/use-calendars'
import useUser from 'shared/hooks/use-user'
import { hasWorkspaces } from 'shared/hooks/use-user/utils/has-workspaces'

export interface HotsEmailAddressProps {
  googleIntegrationId: string | undefined
}

export const HostEmailAddress = ({ googleIntegrationId }: HotsEmailAddressProps) => {
  const { t } = useLocoTranslation()
  const { user, isWorkspaceOwner } = useUser()

  const [hostEmailAddress, setHostEmailAddress] = useState<string>('')

  const { data: calendars } = useCalendars()

  useEffect(() => {
    if (!user) return

    if (calendars) {
      if (googleIntegrationId) {
        const calendar = calendars.find(item => item.integration.id === googleIntegrationId)
        if (calendar) {
          setHostEmailAddress(calendar.integration.googleUserEmail)
          return
        }
      }
    }

    if (!isWorkspaceOwner && hasWorkspaces(user)) {
      const membership = user.workspaceMemberships.find(ws => ws.ownerId === user.workspaceOwner)
      if (membership) {
        setHostEmailAddress(membership.workspaceOwner.email)
        return
      }
    }

    if (user.mainUser) {
      setHostEmailAddress(user.mainUser.user.email)
    }
  }, [user, isWorkspaceOwner, calendars, googleIntegrationId])

  return (
    <Hint label={t('dashboard.calendar.host_email_address_hint')}>
      <TransLoco
        t={t}
        i18nKey={'dashboard.calendar.host_email_address'}
        values={{ email: hostEmailAddress }}
        components={{
          b: <b />,
        }}
      />
    </Hint>
  )
}
